/**
 * Plugin: WhatsApp Cloud API (Meta Oficial).
 * Implementa o ChannelPlugin contract.
 */

import React from 'react';
import { IconBrandMeta } from '@tabler/icons-react';
import { CHANNEL_CATEGORIES } from '../../types';

import useStatus from './useStatus';
import Card from './Card';
import Detail from './Detail';
import ConnectFlow from './ConnectFlow';

const WhatsAppCloudApiChannel = {
  id: 'whatsapp_cloud_api',
  name: 'WhatsApp Oficial',
  description: 'Conexão oficial via Meta Business Platform.',
  icon: IconBrandMeta,
  color: '#1877F2',
  gradient: 'linear-gradient(135deg, #1877F2 0%, #0d5bc4 100%)',
  category: CHANNEL_CATEGORIES.MESSAGING,
  isAvailable: true,
  provider: 'cloud_api',
  conflictsWith: ['whatsapp_waha'],

  useStatus,

  renderCard: (agentId, context) => <Card agentId={agentId} context={context} />,
  renderDetail: (agentId, navigation, onAlertCTA) => (
    <Detail agentId={agentId} navigation={navigation} onAlertCTA={onAlertCTA} />
  ),
  renderConnectFlow: (agentId, onConnected, onCancel) => (
    <ConnectFlow agentId={agentId} onConnected={onConnected} onCancel={onCancel} />
  ),
};

export default WhatsAppCloudApiChannel;
